import React, { useState } from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import axios from "axios";
import config from "../../config";

const BASE_IP_URL =
  process.env.IP_URL || "https://ipinfo.io/?token=9415d554205624";

console.log("BASE_IP_URL", BASE_IP_URL);

const initForm = {
  name: "",
  email: "",
  phoneNo: "",
  contactId: "",
  budget: "",
  technology: "",
  contact: "",
};

const intrest = {
  1: "Mobile App Development",
  2: "Web App Development",
  3: "Custom Software Development",
  4: "Remote Dedicated Team",
  5: "IT Support",
  6: "Other",
};

const Contactform = () => {
  const [formData, setFormData] = useState(initForm);
  const [error, setError] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const onChange = (fieldName, value) => {
    setFormData({ ...formData, [fieldName]: value });
  };
  const onPhoneNoChange = (value) => {
    if (/^[0-9]*$/.test(value)) setFormData({ ...formData, phoneNo: value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    // validation
    const tempError = [];
    if (
      formData.email &&
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        formData.email
      )
    )
      tempError.push("emailNotValid");
    ["name", "email", "phoneNo"].forEach((f) => {
      if (!formData[f]) tempError.push(f);
    });
    if (tempError.length) {
      setError(tempError);
      return;
    }
    setError([]);

    // --- NEW: fetch full ipinfo JSON from frontend ---
    let clientIpData = null;
    try {
      const ipRes = await axios.get(BASE_IP_URL, {
        timeout: 5000,
      });
      clientIpData = ipRes?.data || null; // will be the object you pasted earlier
      console.log("contactform clientIpData:", clientIpData);
    } catch (err) {
      // don't block form submit if ipinfo fails - we still send the form without ipinfo
      // eslint-disable-next-line no-console
      console.warn("ipinfo fetch failed (frontend):", err?.message || err);
    }

    // assemble payload (including ip info)
    const payload = {
      ...formData, // name, email, phoneNo, contactId, budget, technology, contact
      clientIpData, // full JSON from ipinfo (or null)
    };

    try {
      const res = await axios.post(`${config.baseUrl}/contactus/form`, payload);
      if (res.data.success) {
        setSuccessMessage("Your details send sucessfully.");
        setFormData(initForm);
      } else {
        setSuccessMessage(""); // or set an error UI if you prefer
      }
    } catch (postErr) {
      // handle error
      console.error("submit error:", postErr);
      setSuccessMessage("");
    }
  };

  return (
    <div className="contactForm">
      <div className="formHeading">
        {successMessage && (
          <div className="alert alert-success" role="alert">
            Your details send sucessfully.
          </div>
        )}
        <h3>Let’s build success together now.</h3>
      </div>
      <form onSubmit={onSubmit}>
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12">
            <TextField
              className="contactInput"
              fullWidth
              label="Full Name*"
              variant="standard"
              name="name"
              value={formData.name}
              onChange={(e) => onChange(e.target.name, e.target.value)}
            />
            {error.includes("name") ? (
              <p className="text-danger error">Please enter full name.</p>
            ) : null}
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <TextField
              className="contactInput"
              fullWidth
              label="Email*"
              variant="standard"
              name="email"
              value={formData.email}
              onChange={(e) => onChange(e.target.name, e.target.value)}
            />
            {error.includes("email") ? (
              <p className="text-danger error">Please enter email.</p>
            ) : null}
            {error.includes("emailNotValid") ? (
              <p className="text-danger error">Please enter valid email.</p>
            ) : null}
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <TextField
              className="contactInput"
              fullWidth
              label="Phone*"
              variant="standard"
              name="phoneNo"
              value={formData.phoneNo}
              onChange={(e) => onPhoneNoChange(e.target.value)}
              inputProps={{ maxLength: 15 }}
            />
            {error.includes("phoneNo") ? (
              <p className="text-danger error">Please enter phone number.</p>
            ) : null}
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <FormControl fullWidth variant="standard" className="contactSelect">
              <InputLabel id="language-standard-label">
                I am interested in
              </InputLabel>
              <Select
                labelId="language-standard-label"
                value={formData.technology}
                name="technology"
                onChange={(e) => onChange(e.target.name, e.target.value)}
                displayEmpty
                inputProps={{ "aria-label": "budget" }}
              >
                {Object.entries(intrest).map(([key, value]) => (
                  <MenuItem key={key} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12">
            <TextField
              className="contactInput"
              fullWidth
              label="Message"
              variant="standard"
              rows={4}
              multiline
              name="contact"
              value={formData.contact}
              onChange={(e) => onChange(e.target.name, e.target.value)}
              inputProps={{ maxLength: 500 }}
              helperText={`${formData.contact.length}/500`}
            />
          </div>
          <div className="col-xl-12 col-lg-12 col-md-12">
            <Button className="submitBtn" type="submit">
              <span>Contact Us</span>
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Contactform;
